import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import { localStorage } from 'dibs-browser-storage';

import { showSuspectedTradeUserAcquisition, TRADE_WINDFALL_REFERRAL_KEY } from './helpers';

const SuspectedTradeUser = React.lazy(() =>
    import(/* webpackChunkName: "SuspectedTradeUser" */ './SuspectedTradeUser')
);

function SuspectedTradeUserLazyComponent({ viewer, userId, relay, isClient }) {
    const [continueShowing, setContinueShowing] = useState(false);
    const tradeStatus = get(viewer, 'user.verifiedTradeStatus');
    //only have the windfall flag supersede trade status if user has none
    const hasWindfallFlag = localStorage.getItem(TRADE_WINDFALL_REFERRAL_KEY) && !tradeStatus;

    const shouldShowSuspectedTrade =
        isClient &&
        showSuspectedTradeUserAcquisition() &&
        (tradeStatus === 'SUSPECTED' || continueShowing || hasWindfallFlag);

    //if the suspected trade palcement is shown this session, keep showing it regardless of prop changes
    if (shouldShowSuspectedTrade && !continueShowing) {
        setContinueShowing(true);
    }

    if (!shouldShowSuspectedTrade) {
        return null;
    }

    return (
        <React.Suspense fallback="">
            <SuspectedTradeUser
                viewer={viewer}
                userId={userId}
                relay={relay}
                onDismissAqcuisition={() => setContinueShowing(true)}
            />
        </React.Suspense>
    );
}

SuspectedTradeUserLazyComponent.propTypes = {
    isClient: PropTypes.bool,
    viewer: PropTypes.object,
    userId: PropTypes.string,
    relay: PropTypes.object,
};

export const SuspectedTradeUserLazy = createFragmentContainer(SuspectedTradeUserLazyComponent, {
    viewer: graphql`
        fragment SuspectedTradeUserLazy_viewer on Viewer {
            contactInfo {
                phoneNumbers {
                    tradeSupport(formatType: INTERNATIONAL)
                }
            }
            user(userId: $userId) @include(if: $hasUserId) {
                verifiedTradeStatus
            }
        }
    `,
});
